// input yyyymmdd
export default function (value, format = 'YYYY/MM/DD') {
  if (!value) {
    return '-'
  }

  if (format === 'MM/DD') {
    return `${value.substr(4, 2)}/${value.substr(6, 2)}`
  }

  return `${value.substr(0, 4)}/${value.substr(4, 2)}/${value.substr(6, 2)}`
}
